import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

import { RootState } from 'storage/store';
import { WelcomeKisaStatus } from 'storage/agreements/agreements.model';
import { EMPTY_ARRAY_LENGTH } from 'utils/consts';
import { findKisaAgreementsIds } from '../utils/findKisaAgreementsIds';

enum KisaWelcome {
  visible = 'visible',
  closed = 'closed'
}
export const kisaWelcomeName = 'KisaWelcome';

const useKisaInfo = () => {
  const [isKisaWelcome, setIsKisaWelcome] = useState<WelcomeKisaStatus>(
    WelcomeKisaStatus.NONE
  );
  const [multiclientAgreements, setMulticlientAgreements] = useState<number[]>(
    []
  );
  const [kisaClosedLabel, setKisaClosedLabel] = useState<string | null>(null);
  const { id } = useSelector((state: RootState) => state.user);
  const { agreements, welcomeKISA } = useSelector(
    (state: RootState) => state.agreements
  );

  const closeKisaWelcome = () => {
    if (kisaClosedLabel) {
      localStorage.setItem(kisaWelcomeName, kisaClosedLabel);
    }
    setIsKisaWelcome(WelcomeKisaStatus.NONE);
  };
  useEffect(() => {
    if (!id) {
      return;
    }
    setKisaClosedLabel(`${KisaWelcome.closed}-${id}`);
  }, [id]);

  useEffect(() => {
    if (!kisaClosedLabel) {
      return;
    }
    const kisaWelcomeInStorage = localStorage.getItem(kisaWelcomeName);
    if (
      kisaWelcomeInStorage === kisaClosedLabel ||
      welcomeKISA === WelcomeKisaStatus.NONE ||
      !agreements ||
      agreements.length === EMPTY_ARRAY_LENGTH
    ) {
      return;
    }
    setIsKisaWelcome(welcomeKISA);
    localStorage.setItem(kisaWelcomeName, KisaWelcome.visible);
    if (welcomeKISA === WelcomeKisaStatus.MULTICLIENT) {
      const kisaAgreementsIds = findKisaAgreementsIds(agreements);
      setMulticlientAgreements(kisaAgreementsIds);
    }
  }, [agreements, kisaClosedLabel, welcomeKISA]);

  return {
    isKisaWelcome,
    multiclientAgreements,
    closeKisaWelcome
  };
};

export default useKisaInfo;
